import { defineComponent as _defineComponent } from 'vue'
import BCXItemsWithPoints from '@/components/molecules/BCXItemsWithPoints.vue';
import BCXButton from '@/components/molecules/BCXButton.vue';
import useProjectsContractsActionState from '@/views/my-projects/components/contracts/myProjectsContractsActionState';
import useContract from '@/views/my-projects/composables/useContract';
import { computed } from 'vue';
import { ContractStatus } from '@/models/Contracts';
import BCXSidebarHelpContainer from '@/components/molecules/BCXSidebarHelpContainer.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectsContractsActionButtons',
  props: {
  inBox: Boolean
},
  setup(__props) {


const {
  events,
  contractDetail,
  isUserCreator
} = useContract();

const canReopenContract = computed(() => [ContractStatus.Canceled, ContractStatus.Signed]
  .includes(
    (contractDetail.value?.status ?? ContractStatus.Running)
  )
  && isUserCreator.value);

const canDeleteContract = computed(() => isUserCreator.value);
const canFinalizeOrAbortContract = computed(() => !canReopenContract.value && isUserCreator.value);

const { mode } = useProjectsContractsActionState();

const onEvent = (event: string) => {
  events.emit(event);
};


return { __sfc: true,events, contractDetail, isUserCreator, canReopenContract, canDeleteContract, canFinalizeOrAbortContract, mode, onEvent, BCXItemsWithPoints, BCXButton, BCXSidebarHelpContainer }
}

})